<template>
  <div></div>
</template>

<script>
export default {
  name: "GetOpenId",
  data() {
    return {};
  },
  mounted() {
    const code = new URLSearchParams(window.location.search).get("code");
    alert(code);
    return;

    if (code) {
      const appid = "wx98a0a8c004d720f5";
      const requestUrl = `https://api.weixin.qq.com/sns/oauth2/access_token?appid=${appid}&secret=YOUR_APP_SECRET&code=${code}&grant_type=authorization_code`;

      fetch(requestUrl)
        .then(response => response.json())
        .then(data => {
          if (data && data.openid) {
            const openid = data.openid;
            alert(openid);
            // 在这里可以存储或使用用户的openid
            // ...
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/GetOpenId/GetOpenId.vue